import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Home from './pages/home'
import Index from './pages/index'
//import VideoLlamada from './pages/video_llamada'
import Base from './pages/base'
import Usuarios from "./pages/usuarios";
import HomeEnProceso from "./pages/home_vidio_atend";
import Restablecer from './pages/restablecer';
import Seguimientos from './pages/seguimientos';
import VideoLlamada from './pages/videollamada'

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/home">
          <Home />
        </Route>
        <Route path="/index">
          <Index />
        </Route>
        <Route path="/video_llamada">
          <VideoLlamada />
        </Route>
        <Route path="/base">
          <Base />
        </Route>
        <Route path="/usuarios">
          <Usuarios />
        </Route>
        <Route path="/en_proceso">
          <HomeEnProceso />
        </Route>
        <Route path="/seguimientos">
          <Seguimientos />
        </Route>
        <Route path="/check">
          <Restablecer />
        </Route>
        <Route path="/">
          <Index />
        </Route>
        </Switch>
    </Router>
  )}

export default App;
